import { z } from 'zod';

const ComparatorSchema = z.enum(['eq', 'neq', 'contains', 'gt', 'lt', 'ex', 'nex', 'none', 'rel']);

export const QueryFilterSchema = z.object({
  field: z.string(),
  comparator: ComparatorSchema,
  values: z.array(z.string()),
});

export const QueryFiltersSchema = z.array(QueryFilterSchema);

export type Comparator = z.infer<typeof ComparatorSchema>;
export type QueryFilter = z.infer<typeof QueryFilterSchema>;
